export default {
    data() {
        return {
            valid: {
                points_label: false,
                name: false,
                description: false,
                logo: false,
                country_id: false,
              
            },
            success: {
                points_label: false,
                name: false,
                description: false,
                logo: false,
                country_id: false,
            },
            error: {
                points_label: "",
                name: "",
                description: "",
                logo: "",
                country_id: "",
            },
            errorMessages: {
                pointsLabelRequired: {
                    el: "Απαιτείται ετικέτα πόντων",
                    en: "Points label is required",
                    it: "L'etichetta dei punti è necessaria"
                },
                countryRequired: {
                    el: "Απαιτείται ετικέτα πόντων",
                    en: "Points label is required",
                    it: "L'etichetta dei punti è necessaria"
                },
                logoRequired: {
                    el: "Απαιτείται λογότυπο",
                    en: "Logo is required",
                    it: "Il logo è richiesto"
                },
                logoInvalid: {
                    el: "Μη έγκυρη εικόνα",
                    en: "Invalid image",
                    it: "Immagine non valido"
                },
                nameRequired: {
                    el: "Το όνομα είναι υποχρεωτικό",
                    en: "Name is required",
                    it: "Il nome è obbligatorio"
                },
                descriptionRequired: {
                    el: "Απαιτείται περιγραφή",
                    en: "Description is required",
                    it: "La descrizione è necessaria"
                },
              
            }
        };
    },

    computed: {
        formValid() {
            console.log(this.valid.name ,
                this.valid.description ,
                this.valid.logo,
                this.valid.points_label)
            return (
                this.valid.name &&
                this.valid.description &&
                this.valid.logo &&
                this.valid.points_label
            );
        }
    },

    methods: {
  
        validatePointsLabel() {
            if (!this.loyaltyProgram.points_label) {
                this.error.points_label = this.errorMessages.pointsLabelRequired[this.lang];
            } else {
                this.error.points_label = "";
                
            }
            this.valid.points_label = !this.error.points_label
        },
        validateCountry() {
            if (!this.loyaltyProgram.country_id) {
                this.error.country_id = this.errorMessages.countryRequired[this.lang];
            } else {
                this.error.country_id = "";
                
            }
            this.valid.country_id = !this.error.country_id
        },

        validateName() {
            if (this.nameLang === "el") {
                if (!this.loyaltyProgram.name["el"]) {
                    this.error.name = this.errorMessages.nameRequired[
                        this.lang
                    ];
                } else {
                    this.error.name = "";
                }
            }
        },

        validateDescription() {
            if (this.descriptionLang === "el") {
                if (!this.loyaltyProgram.description["el"]) {
                    this.error.description = this.errorMessages.descriptionRequired[
                        this.lang
                    ];
                } else {
                    this.error.description = "";
                }
            }
        },

        isValidImage(img) {
            try {
                return ['image/jpg', 'image/jpeg', 'image/png'].includes(img?.type||'')
            } catch (e) {
                return false;
            }
        },
        validateLogo() {
            console.log('validateLogo')
            this.error.logo = "";
            this.success.logo = false
            this.valid.logo = false;
            if (!this.logo.image) {
                    this.error.logo = this.errorMessages.logoRequired[this.lang];
                }
            else if(this.logo?.file && !this.isValidImage(this.logo?.file)){
                this.error.logo = this.errorMessages.imageInvalid[this.lang];
            }
            if (!this.error.logo) {
                this.success.logo = true
                this.valid.logo = true;
            }
        },

        validateForm() {
            this.validateName()
            this.validateDescription()
            this.validatePointsLabel()
            this.validateLogo()
        }
    },

    watch: {

        nameLang(val) {
            if (val === "en" || val === "it") {
                this.error.name = "";
            }
        },

        descriptionLang(val) {
            if (val === "en" || val === "it") {
                this.error.description = "";
            }
        },

        ["loyaltyProgram.name.el"]: {
            immediate: true,
            handler(val) {
                this.valid.name = !!val;
                this.success.name = !!val;
            }
        },

        ["loyaltyProgram.description.el"]: {
            immediate: true,
            handler(val) {
                this.valid.description = !!val;
                this.success.description = !!val;
            }
        },

      

        resetSuccess(val) {
            if (val) {
                this.success = {
                points_label: false,
                name: false,
                description: false,
                logo: false,
                country_id: false,
            };

                this.setResetSuccess(false);
            }
        },

        resetValidation: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error = {
                        points_label: "",
                        name: "",
                        description: "",
                        logo: "",
                        country_id: "",
                    };

                    this.setResetValidation(false);
                }
            }
        }
    }
};
